/**
 * Onboarding Route Map — CANON v1.3.0
 * 
 * Maps legacy routes to canonical destinations.
 * 
 * IMPORTANT: /verify/* routes are DEPRECATED.
 * Canonical destinations are:
 * - /dashboard (for existing users)
 * - /onboarding/wizard (for new users)
 * 
 * See: docs/architecture/KYC_VERIFICATION_FLOW_CANON.md
 */
const ONBOARDING_ROUTES: Record<string, string> = {
  // Legacy KYC routes → redirect to dashboard (canonical)
  '/kyc/start': '/dashboard',
  '/kyc/resume': '/dashboard',
  '/kyc/pending': '/dashboard',
  
  // Legacy verify routes → redirect to dashboard (canonical)
  '/verify/start': '/dashboard',
  '/verify/resume': '/dashboard',
  '/verify/status': '/dashboard',
  '/verify': '/dashboard',
  
  // Access denied
  '/blocked': '/user-access-denied',
  
  // Canonical routes (no change)
  '/dashboard': '/dashboard',
  '/onboarding/profile': '/onboarding/profile',
  '/onboarding/wizard': '/onboarding/wizard',
};

const CANONICAL_DESTINATIONS = new Set([
  '/dashboard',
  '/onboarding/wizard',
  '/onboarding/profile',
  '/user-access-denied',
]);

// CANON v1.3.0: Default to dashboard, NOT /verify
const DEFAULT_DESTINATION = '/dashboard';

export function normalizeNextRoute(nextRoute: string | null | undefined): string {
  if (!nextRoute) {
    return DEFAULT_DESTINATION;
  }
  if (ONBOARDING_ROUTES[nextRoute]) {
    return ONBOARDING_ROUTES[nextRoute];
  }
  if (CANONICAL_DESTINATIONS.has(nextRoute)) {
    return nextRoute;
  }
  return nextRoute;
}

export function isOnboardingRoute(route: string | null | undefined): boolean {
  if (!route) return false;
  return Object.prototype.hasOwnProperty.call(ONBOARDING_ROUTES, route) || CANONICAL_DESTINATIONS.has(route);
}

export { ONBOARDING_ROUTES };
